
import { SVGProps, memo } from 'react';
const FileIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66638 0.866211H8.18884V5.36816C8.18884 6.21493 8.87531 6.90223 9.72205 6.90234H13.4672V15.999C13.4672 16.0727 13.407 16.1328 13.3334 16.1328H1.66638C1.59289 16.1326 1.53357 16.0726 1.53357 15.999V0.999023C1.53374 0.925645 1.593 0.866387 1.66638 0.866211ZM9.58923 2.03027L12.6244 5.50195H9.72205C9.64851 5.50184 9.58923 5.44173 9.58923 5.36816V2.03027Z" stroke={props.color || "#424242"} stroke-width="1.4"/>
</svg>
);

export default memo(FileIcon2);
